export type Therapist = {
  id: string;
  name: string;
  title: string;
  level: "junior" | "middle" | "senior" | "expert";
  approaches: string[];
  topics: string[];
  price: number;
  rating: number;
  reviews: number;
  experience: number;
  formats: Array<"Видео" | "Чат" | "Аудио">;
  slots: string[];
  timeTags: string[];
  evidence: "Доказательные методы" | "Интегративный подход" | "Немедицинский метод";
  reason: string;
  limits: string;
  portraitIndex: number;
};

export const therapists: Therapist[] = [
  {
    id: "anna",
    name: "Анна Смирнова",
    title: "КПТ, ACT, EMDR",
    level: "senior",
    approaches: ["КПТ", "ACT", "EMDR"],
    topics: ["Мне тревожно", "Выгорание", "Стресс"],
    price: 6000,
    rating: 4.9,
    reviews: 126,
    experience: 7,
    formats: ["Видео", "Чат"],
    slots: ["Сегодня 20:00", "Сегодня 22:00", "Завтра 10:00"],
    timeTags: ["Сегодня вечером", "Завтра"],
    evidence: "Доказательные методы",
    reason:
      "Работает с тревогой и выгоранием, использует структурные методы и даёт понятный план первых сессий.",
    limits: "Не ведёт медицинскую диагностику и кризисные обращения без поддержки служб помощи.",
    portraitIndex: 0,
  },
  {
    id: "igor",
    name: "Игорь Лебедев",
    title: "КПТ, схема-терапия",
    level: "middle",
    approaches: ["КПТ", "Схема-терапия"],
    topics: ["Выгорание", "Прокрастинация", "Самооценка"],
    price: 5500,
    rating: 4.8,
    reviews: 98,
    experience: 6,
    formats: ["Видео", "Аудио"],
    slots: ["Сегодня 21:00", "Завтра 12:00", "Сб 11:00"],
    timeTags: ["Сегодня вечером", "Выходные"],
    evidence: "Доказательные методы",
    reason:
      "Фокусируется на практических инструментах, привычках и снижении нагрузки без давления на клиента.",
    limits: "Не работает с зависимостями и острыми кризисными состояниями.",
    portraitIndex: 1,
  },
  {
    id: "maria",
    name: "Мария Волкова",
    title: "ACT, CFT",
    level: "senior",
    approaches: ["ACT", "CFT"],
    topics: ["Самооценка", "Отношения", "Выгорание"],
    price: 6500,
    rating: 4.9,
    reviews: 140,
    experience: 8,
    formats: ["Видео", "Чат"],
    slots: ["Завтра 10:00", "Завтра 19:00", "Пн 20:00"],
    timeTags: ["Завтра", "Будни вечером"],
    evidence: "Доказательные методы",
    reason:
      "Подходит, если важны бережная работа с самокритикой, ценностями и отношениями.",
    limits: "Не обещает быстрый результат и не заменяет медицинскую помощь.",
    portraitIndex: 4,
  },
  {
    id: "dmitry",
    name: "Дмитрий Орлов",
    title: "Семейная терапия",
    level: "expert",
    approaches: ["Системный подход", "EFT"],
    topics: ["Отношения", "Стресс", "Утрата, горе"],
    price: 9000,
    rating: 4.9,
    reviews: 173,
    experience: 11,
    formats: ["Видео"],
    slots: ["Сб 12:00", "Сб 16:00", "Вт 20:00"],
    timeTags: ["Выходные", "Будни вечером"],
    evidence: "Интегративный подход",
    reason:
      "Сильный вариант для парных и семейных запросов, границ, конфликтов и повторяющихся сценариев.",
    limits: "Не проводит срочные кризисные консультации в тот же день.",
    portraitIndex: 2,
  },
  {
    id: "elena",
    name: "Елена Коваль",
    title: "Гештальт, телесный подход",
    level: "middle",
    approaches: ["Гештальт", "Телесный подход"],
    topics: ["Стресс", "Утрата, горе", "Отношения"],
    price: 4800,
    rating: 4.7,
    reviews: 74,
    experience: 5,
    formats: ["Видео", "Чат"],
    slots: ["Завтра 18:00", "Пн 11:00", "Вт 18:00"],
    timeTags: ["Завтра", "Будни утром"],
    evidence: "Интегративный подход",
    reason:
      "Может подойти, если хочется мягко разобрать эмоции и телесные реакции на стресс.",
    limits: "Метод требует личной проверки контакта и не является медицинским лечением.",
    portraitIndex: 3,
  },
  {
    id: "roman",
    name: "Роман Миронов",
    title: "Коучинг устойчивости",
    level: "junior",
    approaches: ["Коучинг", "Психообразование"],
    topics: ["Прокрастинация", "Самооценка", "Другое"],
    price: 3500,
    rating: 4.6,
    reviews: 51,
    experience: 3,
    formats: ["Видео", "Чат"],
    slots: ["Сегодня 18:00", "Завтра 21:00", "Вс 15:00"],
    timeTags: ["Сегодня вечером", "Выходные"],
    evidence: "Немедицинский метод",
    reason:
      "Подходит для мягкого старта, постановки целей и поддержки между терапевтическими решениями.",
    limits: "Не работает с клиническими симптомами и сложными кризисными состояниями.",
    portraitIndex: 5,
  },
];

export const requestOptions = [
  "Мне тревожно",
  "Выгорание",
  "Отношения",
  "Самооценка",
  "Стресс",
  "Прокрастинация",
  "Утрата, горе",
  "Другое",
];

export const budgetOptions = ["До 3 тыс. ₽", "5-8 тыс. ₽", "8-12 тыс. ₽", "12+ тыс. ₽"];
export const formatOptions = ["Видео", "Чат", "Аудио"] as const;
export const timeOptions = ["Сегодня вечером", "Завтра", "Выходные", "Будни утром", "Будни вечером"];
